module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/twitter-white-45c50ad0fa98e8285aae18e28c086449.svg";